import _ from 'lodash';

export const checkRole = (userRoleArr, roleForCheck) => {
    const checked = _.includes(userRoleArr, roleForCheck);
    return checked;
}


// WEBPACK FOOTER //
// ./src/utils/checkRole.js